import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './PageValidation.scss';

class PageValidation extends Component {
  render() {
    let pageValidation = <div className="empty-error-confirm"></div>;

    if(this.props.visible) {
      pageValidation = <div className="error-confirm">{this.props.message}</div>
    }
    return pageValidation;
  }
}

PageValidation.defaultProps= {  
  message: "",
  visible: false
};

PageValidation.propTypes = {
  message: PropTypes.string,
  visible: PropTypes.bool
};

export default PageValidation;


// WEBPACK FOOTER //
// ./src/components/PageValidation/PageValidation.js